// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2QYq9","detailsBorder":"styles_detailsBorder__1_Czh"};